import { FC } from 'react'

import styled, { keyframes, css } from 'styled-components'

import { Txt } from 'src/components/atoms'

const flash = keyframes`
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
`

const Container = styled.div<{ isSelected: boolean }>`
  &::after {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);

    display: block;
    content: '';
    width: ${({ isSelected }) => (isSelected ? '3.57rem' : 0)};
    height: 4px;
    transition: width 0.25s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  cursor: ${({ isSelected }) => (isSelected ? 'default' : 'pointer')};

  &:hover {
    ${({ isSelected }) =>
      !isSelected &&
      css`
        animation: ${flash} 1s;

        &::after {
          width: 3.57rem;
        }
      `}
  }
`

type Props = {
  text: string
  isSelected?: boolean
  select: () => void
  className?: string
}

export const MemberTypeSwitchTab: FC<Props> = ({ text, isSelected = false, select, className }) => {
  return (
    <div className={className}>
      <Container
        isSelected={isSelected}
        className="tw-w-[11.43rem] tw-h-[3.57rem] tw-centering tw-relative after:tw-bg-roovPrimary-default hover:after:tw-bg-standardText-disable"
        onClick={select}
      >
        <Txt className={`${isSelected ? 'tw-font-bold tw-text-roovPrimary-default' : ''}`}>
          {text}
        </Txt>
      </Container>
    </div>
  )
}
